

export default function Height2Icon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.71903 15.0201C7.88072 15.1706 8.13382 15.1615 8.28436 14.9999L10.7375 12.3651C10.888 12.2034 10.879 11.9503 10.7173 11.7997C10.5556 11.6492 10.3025 11.6582 10.152 11.8199L7.97141 14.162L5.62936 11.9814C5.46767 11.8309 5.21457 11.8399 5.06403 12.0016C4.9135 12.1633 4.92254 12.4164 5.08422 12.5669L7.71903 15.0201ZM7.78237 0.943152C7.62069 0.792618 7.36758 0.801656 7.21705 0.963341L4.76393 3.59815C4.6134 3.75984 4.62244 4.01294 4.78412 4.16348C4.94581 4.31401 5.19891 4.30497 5.34945 4.14329L7.52999 1.80123L9.87205 3.98178C10.0337 4.13232 10.2868 4.12328 10.4374 3.96159C10.5879 3.79991 10.5789 3.5468 10.4172 3.39627L7.78237 0.943152ZM7.9916 14.7273L8.39135 14.713L7.90955 1.22163L7.5098 1.23591L7.11006 1.25019L7.59186 14.7416L7.9916 14.7273Z" fill="black" />
        </svg>



    )
}